
import { defineComponent } from "vue";
import { Field } from "vee-validate";

export interface SelectOptions {
  label: string;
  value: string;
}

export interface NestedSelectOptions {
  label: string;
  key: string;
  options: SelectOptions[];
}

export default defineComponent({
  name: "PullDownSelect",
  components: {
    Field,
  },
  props: {
    options: {
      type: [
        Array as () => SelectOptions[],
        Array as () => NestedSelectOptions[],
      ],
      default: () => [{ label: "", value: "" }],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    placeHolder: {
      type: String,
      default: "選択してください",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: "",
    },
    rules: {
      type: Object,
    },
  },
  computed: {
    isOptionsNested(): boolean {
      return this.options.some((elm) => {
        if (!(elm as NestedSelectOptions).options) return false;
        if (!(elm as NestedSelectOptions).key) return false;
        return Array.isArray((elm as NestedSelectOptions).options);
      });
    },
  },
  methods: {
    onChange(event: Event): void {
      this.$emit("change", event);
      if (event.target instanceof HTMLSelectElement) {
        this.$emit("update:modelValue", event.target.value);
      }
    },
  },
  emits: ["change", "update:modelValue"],
});
